import { FetchQueryOptions, QueryClient, QueryKey } from '@tanstack/react-query'
import { redirect } from 'next/navigation'

import { Pagination } from '@/shared/api'

export const fetchPaginatedData = async <
  TData extends Pagination<unknown>,
  TError,
  TQueryKey extends QueryKey,
>({
  page,
  options,
  redirectTo,
}: {
  page?: string
  options: FetchQueryOptions<TData, TError, TData, TQueryKey>
  redirectTo: string
}) => {
  const queryClient = new QueryClient()

  const data = await queryClient.fetchQuery(options)

  const afterLastPage = data?.lastPage && Number(page) > data.lastPage
  const notFirstPage = !isNaN(Number(page)) && Number(page) > 1

  if (afterLastPage && notFirstPage) {
    const { lastPage } = data

    const pageParam = lastPage > 1 ? `?page=${lastPage}` : ''

    redirect(`${redirectTo}${pageParam}`)
  }

  return queryClient
}
